;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import {
  AbaBankCreateRequest,
  Address,
  AddressRequest,
  AllocationLineListResponse,
  AllocationsList,
  BookableCarrier,
  Brand,
  BrandNameFacetSearch,
  BrandRequestRequest,
  Cart,
  CartAllocationList,
  CartLine,
  CartLineRequest,
  CartLineRequestWritable,
  CartSummary,
  CartUploadCancelResponse,
  CartUploadRequest,
  CartUploadResponse,
  CategoryDetailResponse,
  Checkout,
  CheckoutCompleteRequest,
  CheckoutCompleteResponse,
  CheckoutPrepareRequest,
  CheckoutRetrieveUpdate,
  CheckoutValidateRequest,
  CheckoutValidationResponse,
  Claim,
  ClaimDisputeInputRequest,
  ClaimEvidenceQuestionEvaluationRequestRequest,
  ClaimEvidenceQuestionEvaluationResponse,
  ClaimHistoryDetailOutput,
  ClaimQid,
  ClaimRequest,
  Country,
  CreateMembershipRequest,
  CreateSellerBrandRestrictionRequest,
  CreateSellerLeadRequest,
  CreateUserBuyerExporterRequest,
  CurrentUser,
  EmailTokenVerify,
  EmailTokenVerifyRequest,
  EmailValidationPostRequest,
  EmailValidationPostResponse,
  File,
  FileRequest,
  IbanBankCreateRequest,
  InitialCheckRequestRequestWritable,
  InitialCheckResponse,
  InitialCheckTaskResult,
  InternalOrderSales,
  IssueType,
  LostShipmentClaimRequest,
  MonduApplication,
  MonduApplicationRequest,
  ObtainToken,
  ObtainTokenRequest,
  Offer,
  OfferAvailabilityRequest,
  OfferInfo,
  OfferSearch,
  OptimizeCartRequest,
  OrderClaimStatus,
  OrderSaleIssueInputRequest,
  PaginatedAddressList,
  PaginatedBrandContactList,
  PaginatedBrandList,
  PaginatedBrandSearch,
  PaginatedCategoryResponseList,
  PaginatedCheckoutLineList,
  PaginatedClaimHistoryOutputList,
  PaginatedOfferList,
  PaginatedOffersRecommendationsSearch,
  PaginatedOffersSearch,
  PaginatedSaleLineGenericOutputList,
  PaginatedSaleList,
  PaginatedShippingCarrierList,
  PaginatedWalletLineList,
  PasswordChange,
  PasswordChangeRequest,
  PatchedCartAllocationLineRequest,
  PatchedCheckoutRequest,
  PatchedCurrentUserRequest,
  PatchedSaleLineGenericRequest,
  PatchedSaleRequest,
  PhoneTokenVerify,
  PhoneTokenVerifyRequest,
  PhoneVerify,
  PhoneVerifyRequest,
  PlaidInstitution,
  RecommendedBrandsGetResponse,
  RefreshToken,
  RetrieveBank,
  Sale,
  SaleCarrierBookingInputRequest,
  SaleCarrierBookingOutput,
  SaleDeclineRequest,
  SaleIssueInputRequest,
  SaleLineGenericOutput,
  SaleLinesBulkUpdateInputRequest,
  SaleSearch,
  SaleWithHiddenOffers,
  SavedSearch,
  SavedSearchUpdateRequest,
  SearchSuggestions,
  SellerBrandRestrictionRead,
  SellerCurrency,
  SellerLead,
  SellerLeadListItem,
  SellerRecommendationResponse,
  SellerShipmentsResponse,
  SellerStatsOutput,
  ShipmentInputRequest,
  SortCodeBankCreateRequest,
  Statistics,
  StocklistSourceStatus,
  Supplier,
  SupplierOfferResponse,
  SwiftCodeBankDefaultAddressCreateRequest,
  UpdateSellerBrandRestrictionRequest,
  UploadCartPreview,
  UploadCartPreviewRequest,
  UsageTypes,
  User,
  UserDebtor,
  UserGroups,
  UserRegister,
  UserRegisterRequest,
  ValidateTokenRequest,
  ValidateTokenResponse,
  VariantOffersResponse,
  VariantOutput,
  VariantRequestRequest,
  VatList,
  VatValidationPostRequestBodyRequest,
  VatValidationPostResponse,
  Wallet,
  WalletWithdrawalRequest,
} from '@qogita/canary-client'
import { CartPreviewGtinsData } from '@qogita/canary-client/buyers'
import endpointsList from '@qogita/canary-client/endpoints'
import {
  OfferOrdering,
  PaginatedOffersResult,
  PaginatedStocklistSourcesResult,
  StocklistSourceExpiryStatus,
  StocklistSourceInfoSchema,
  StocklistSourceNameSchema,
} from '@qogita/canary-client/sellers'
import { parseCookie, stringifySetCookie } from 'cookie'
import ky, { BeforeRequestHook, HTTPError } from 'ky'
import { match } from 'path-to-regexp'
import { z } from 'zod'

/**
 * Convert from /path/{param}/path/{param} to /path/:param/path/:param
 * to make it compatible with the path-to-regexp lib
 * */
function openApiPathToPathRegex(path: string): string {
  return path.replaceAll(/{(\w+)}/g, ':$1')
}

const endpoints = z
  .string()
  .array()
  .parse(endpointsList)
  .map(openApiPathToPathRegex)

export class CanaryClientHttpError extends HTTPError {
  public fingerprint: string
  public details: {
    url: string
    pathPattern: string
    httpStatus: number
    method: string
    requestJson?: unknown
    responseJson?: unknown
  }

  constructor(originalHttpError: HTTPError, redactedRequest?: Request) {
    const request = redactedRequest ?? originalHttpError.request
    super(originalHttpError.response, request, originalHttpError.options)
    this.name = 'CanaryClientHttpError'
    // Preserve the stack from ky's original error (not from a re-created HTTPError).
    this.stack = originalHttpError.stack

    const response = originalHttpError.response.clone()
    const options = originalHttpError.options

    // Extract the path from the url, and make sure it starts with /
    let path = request.url.split('?')[0]
    path = path?.split(options.prefixUrl)[1] || '/'
    path = path.startsWith('/') ? path : `/${path}`

    // Match the path against the endpoints list
    const pathPattern =
      endpoints.find((pattern) => match(pattern)(path)) || 'UNSET'

    this.message = `[${response.status}] ${request.method} ${pathPattern}`
    this.fingerprint = `${request.method} ${pathPattern} ${response.status}`
    this.details = {
      url: request.url,
      httpStatus: response.status,
      method: request.method,
      pathPattern,
    }
  }

  private async getResponseJson(): Promise<{
    data: unknown | null
    error: Error | null
  }> {
    try {
      const data = await this.response.clone().json()
      return { data, error: null }
    } catch (error) {
      return {
        data: null,
        error: error instanceof Error ? error : new Error(String(error)),
      }
    }
  }

  private async getRequestJson(): Promise<{
    data: unknown | null
    error: Error | null
  }> {
    try {
      const data = await this.request.clone().json()

      // remove headers from the request
      if (data && typeof data === 'object' && 'headers' in data) {
        data.headers = undefined
      }

      return { data, error: null }
    } catch (error) {
      return {
        data: null,
        error: error instanceof Error ? error : new Error(String(error)),
      }
    }
  }

  /**
   * Set request and response data to log together with the error.
   */
  public async setDetailsData() {
    const [requestData, responseData] = await Promise.all([
      this.getRequestJson(),
      // the response is redcated on datadog with
      // https://app.datadoghq.eu/sensitive-data-scanner/configuration/
      this.getResponseJson(),
    ])

    let redactedData = null

    if (typeof requestData.data == 'object') {
      redactedData = { ...requestData.data }

      if ('password' in redactedData) {
        delete redactedData.password
      }

      if ('password2' in redactedData) {
        delete redactedData.password2
      }

      if ('secret' in redactedData) {
        delete redactedData.secret
      }
    }

    this.details.requestJson = {
      error: requestData.error,
      data: redactedData,
    }
    this.details.responseJson = responseData
  }
}

export type CanaryClientConfig = {
  prefixUrl: string
  accessToken?: string
  refresh?: {
    token: string
    cookieName: string
  }
  beforeRequest?: BeforeRequestHook[]
  /** Identifier of the application using the client to help with observability logging */
  xQogitaApplication?: string
  defaultHeaders?: Record<string, string>
}

/**
 * @deprecated use @qogita/canary-client instead (available only for BFF)
 */
export class CanaryClient {
  private readonly ky: typeof ky
  private readonly refresh:
    | {
        token: string
        cookieName: string
      }
    | undefined

  constructor({
    prefixUrl,
    accessToken,
    refresh,
    beforeRequest = [],
    xQogitaApplication = 'Canary Web Client',
    defaultHeaders = {},
  }: CanaryClientConfig) {
    this.ky = ky.create({
      prefixUrl,
      retry: {
        limit: 0, // We control retries in React Query
      },
      timeout: false, // We control timeouts in vercel
      credentials: 'include',
      headers: defaultHeaders,
      hooks: {
        beforeError: [
          async (httpError) => {
            const redactedRequest = httpError.request.clone()
            redactedRequest.headers.set('Authorization', `[REDACTED]`)
            redactedRequest.headers.set('cookie', `[REDACTED]`)

            const error = new CanaryClientHttpError(httpError, redactedRequest)
            await error.setDetailsData()
            return error
          },
        ],
        beforeRequest: [
          (request) => {
            if (accessToken) {
              request.headers.set('Authorization', `Bearer ${accessToken}`)
            }
            if (refresh) {
              request.headers.set(
                'cookie',
                stringifySetCookie({
                  name: refresh.cookieName,
                  value: refresh.token,
                }),
              )
            }
            request.headers.set('x-qogita-application', xQogitaApplication)
          },
          ...beforeRequest,
        ],
      },
    })
    this.refresh = refresh
  }

  // Shared methods
  // Address methods
  getAddresses({
    page,
    size,
    usageType,
  }: { page?: number; size?: number; usageType?: UsageTypes } = {}) {
    const searchParams = new URLSearchParams()
    if (page) {
      searchParams.append('page', String(page))
    }
    if (size) {
      searchParams.append('size', String(size))
    }
    if (usageType) {
      searchParams.append('usageTypes', usageType)
    }
    return this.ky
      .get(`addresses/?${searchParams.toString()}`)
      .json<PaginatedAddressList>()
  }
  getAddress(qid: string) {
    return this.ky.get(`addresses/${qid}/`).json<Address>()
  }
  updateAddress(qid: string, data: AddressRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 400) {
                return error
              }
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                updateAddressBadRequestErrorSchema.safeParse(errorBody)
              if (parsedErrorBodyResult.success) {
                return new UpdateAddressBadRequestError(
                  error,
                  parsedErrorBodyResult.data,
                )
              }
              return error
            },
          ],
        },
      })
      .put(`addresses/${qid}/`, { json: data })
      .json<Address>()
  }
  createAddress(data: AddressRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 400) {
                return error
              }
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                createAddressBadRequestErrorSchema.safeParse(errorBody)
              if (parsedErrorBodyResult.success) {
                return new CreateAddressBadRequestError(
                  error,
                  parsedErrorBodyResult.data,
                )
              }
              return error
            },
          ],
        },
      })
      .post(`addresses/`, { json: data })
      .json<Address>()
  }
  deleteAddress(qid: string) {
    return this.ky.delete(`addresses/${qid}/`).json<void>()
  }

  // Info methods
  getInfo() {
    return this.ky.get('info/').json<Statistics>()
  }
  // User methods
  getUser() {
    return this.ky.get('user/').json<CurrentUser>()
  }
  /**
   * Intentionally broken endpoint used for observability/error testing only.
   * This should trigger a 404 and exercise HTTP error instrumentation paths.
   */
  getUserBroken() {
    return this.ky.get('users').json<CurrentUser>()
  }
  registerUser(data: UserRegisterRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              // We only have special error handling for 400s as anything else is simple
              if (error.response.status !== 400) return error

              const errorSchema = z.object({
                code: z.literal('invalid'),
                message: z.string(),
                lineNumber: z.array(z.string()).optional(),
                // There could be other fields here, but we don't care about them at the moment
                // Add them if you need them
              })
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult = errorSchema.safeParse(errorBody)
              if (!parsedErrorBodyResult.success) return error
              return new CreateUserBadRequestError(
                error,
                parsedErrorBodyResult.data,
              )
            },
          ],
        },
      })
      .post('users/register/', { json: data })
      .json<UserRegister>()
  }

  updateUser(data: PatchedCurrentUserRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 400) return error
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                updateUserBadRequestErrorSchema.safeParse(errorBody)
              if (parsedErrorBodyResult.success) {
                return new UpdateUserBadRequestError(
                  error,
                  parsedErrorBodyResult.data,
                )
              }
              return error
            },
          ],
        },
      })
      .patch('user/', { json: data })
      .json<CurrentUser>()
  }
  /** @deprecated Use updateUserPasswordAppRouter instead */
  updateUserPassword(data: PasswordChangeRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 400) return error

              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                updateUserPasswordBadRequestErrorSchema.safeParse(errorBody)

              if (parsedErrorBodyResult.success) {
                return new UpdateUserPasswordBadRequestError(error)
              }

              return error
            },
          ],
        },
      })
      .put('user/password/', { json: data, credentials: 'include' })
      .json<PasswordChange>()
  }
  async updateUserPasswordAppRouter(
    data: PasswordChangeRequest,
    {
      canaryRefreshTokenCookieName,
      source,
    }: { canaryRefreshTokenCookieName: string; source?: 'seller-onboarding' },
  ) {
    const urlSearchParams = new URLSearchParams()
    if (source) {
      urlSearchParams.set('source', source)
    }
    const response = await this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 400) return error

              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                updateUserPasswordBadRequestErrorSchema.safeParse(errorBody)

              if (parsedErrorBodyResult.success) {
                return new UpdateUserPasswordBadRequestError(error)
              }

              return error
            },
          ],
        },
      })
      .put<PasswordChange>(`user/password/?${urlSearchParams}`, {
        json: data,
        credentials: 'include',
      })
    const responseCookies = parseCookie(
      response.headers.get('set-cookie') ?? '',
    )
    const newRefreshToken = responseCookies[canaryRefreshTokenCookieName] ?? ''
    const responseJson = await response.json()

    return {
      refreshToken: newRefreshToken,
      ...responseJson,
    }
  }
  createUserBuyerExporter(data: CreateUserBuyerExporterRequest) {
    return this.ky.post('user/buyer-exporter/', { json: data }).json<User>()
  }
  getUserBankInfo() {
    return this.ky.get('user/bank/info/').json<RetrieveBank>()
  }
  createUserBankAba(data: AbaBankCreateRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 400) return error
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                createUserBankBadRequestErrorSchema.safeParse(errorBody)
              if (parsedErrorBodyResult.success) {
                return new CreateUserBankBadRequestError(
                  error,
                  parsedErrorBodyResult.data,
                )
              }
              return error
            },
          ],
        },
      })
      .post('user/bank/aba/', { json: data })
      .json<RetrieveBank>()
  }
  createUserBankIban(data: IbanBankCreateRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 400) return error
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                createUserBankBadRequestErrorSchema.safeParse(errorBody)
              if (parsedErrorBodyResult.success) {
                return new CreateUserBankBadRequestError(
                  error,
                  parsedErrorBodyResult.data,
                )
              }
              return error
            },
          ],
        },
      })
      .post('user/bank/iban/', { json: data })
      .json<RetrieveBank>()
  }
  createUserBankSortCode(data: SortCodeBankCreateRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 400) return error
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                createUserBankBadRequestErrorSchema.safeParse(errorBody)
              if (parsedErrorBodyResult.success) {
                return new CreateUserBankBadRequestError(
                  error,
                  parsedErrorBodyResult.data,
                )
              }
              return error
            },
          ],
        },
      })
      .post('user/bank/sortcode/', { json: data })
      .json<RetrieveBank>()
  }
  createUserBankSwiftCodeDefaultAddress(
    data: SwiftCodeBankDefaultAddressCreateRequest,
  ) {
    return this.ky
      .post('user/bank/swiftcode/defaultaddress/', { json: data })
      .json<RetrieveBank>()
  }
  getUserDebtor() {
    return this.ky.get('user/debtor/').json<UserDebtor>()
  }
  getUserGroups() {
    return this.ky.get('user/groups/').json<UserGroups>()
  }
  resendTokenEmail(data: ValidateTokenRequest) {
    return this.ky.post('user/email/resend-token/', { json: data }).json<void>()
  }
  requestVerifyUserEmail() {
    return this.ky.post('user/email/verify/').json<void>()
  }
  confirmVerifyUserEmail(data: EmailTokenVerifyRequest) {
    return this.ky
      .post('user/email/verify-token/', { json: data })
      .json<EmailTokenVerify>()
  }
  requestVerifyUserPhone(data: PhoneVerifyRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 429) return error
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                phoneVerifyThrottleErrorSchema.safeParse(errorBody)
              if (!parsedErrorBodyResult.success) {
                return error
              }
              const waitSeconds = Number(parsedErrorBodyResult.data.wait)
              return new PhoneVerifyThrottleError(error, { waitSeconds })
            },
          ],
        },
      })
      .post('user/phone/verify/', { json: data })
      .json<PhoneVerify>()
  }
  confirmVerifyUserPhone(data: PhoneTokenVerifyRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 400) {
                return error
              }
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                confirmVerifyUserPhoneBadRequestErrorSchema.safeParse(errorBody)
              if (parsedErrorBodyResult.success) {
                return new ConfirmVerifyUserPhoneBadRequestError(
                  error,
                  parsedErrorBodyResult.data,
                )
              }
              return error
            },
          ],
        },
      })
      .post('user/phone/verify-token/', { json: data })
      .json<PhoneTokenVerify>()
  }
  // Auth methods
  login(data: ObtainTokenRequest) {
    return this.ky.post('auth/login/', { json: data }).json<ObtainToken>()
  }

  /** @deprecated Use logoutAppRouter instead */
  logout() {
    return this.ky.post('user/logout/', { credentials: 'include' }).json<void>()
  }

  logoutAppRouter({
    refreshToken,
    accessToken,
    canaryRefreshTokenCookieName,
  }: {
    refreshToken: string
    accessToken: string
    canaryRefreshTokenCookieName: string
  }) {
    return this.ky
      .extend({
        hooks: {
          beforeRequest: [
            (request) => {
              request.headers.set('Authorization', `Bearer ${accessToken}`)
              request.headers.set(
                'cookie',
                stringifySetCookie({
                  name: canaryRefreshTokenCookieName,
                  value: refreshToken,
                }),
              )
            },
          ],
        },
      })
      .post('user/logout/', { credentials: 'include' })
      .json<void>()
  }

  refreshToken() {
    return this.ky.post('auth/refresh/').json<RefreshToken>()
  }

  async refreshTokenAppRouter({
    refreshToken,
    canaryRefreshTokenCookieName,
    rotate,
  }: {
    refreshToken: string
    canaryRefreshTokenCookieName: string
    rotate?: 'false'
  }) {
    const urlSearchParams = new URLSearchParams()
    if (rotate !== undefined) {
      urlSearchParams.set('rotate', rotate)
    }

    const response = await this.ky
      .extend({
        hooks: {
          beforeRequest: [
            (request) => {
              request.headers.set(
                'cookie',
                stringifySetCookie({
                  name: canaryRefreshTokenCookieName,
                  value: refreshToken,
                }),
              )
            },
          ],
        },
      })
      .post<RefreshToken>(`auth/refresh/?${urlSearchParams}`, {
        credentials: 'include',
      })
    const responseCookies = parseCookie(
      response.headers.get('set-cookie') ?? '',
    )
    const newRefreshToken = responseCookies[canaryRefreshTokenCookieName]

    if (!newRefreshToken) {
      throw new Error(
        'Refresh token cookie not found in auth/refresh/ response',
      )
    }
    const responseJson = await response.json()
    return {
      refreshToken: newRefreshToken,
      ...responseJson,
    }
  }

  async loginAppRouter(data: ObtainTokenRequest) {
    const response = await this.ky.post<ObtainToken>(`auth/login/`, {
      credentials: 'include',
      json: data,
    })

    const responseCookies = parseCookie(
      response.headers.get('set-cookie') ?? '',
    )
    const refreshTokenResponse = responseCookies['Refresh-Token']
    if (!refreshTokenResponse) {
      throw new Error(
        'Refresh token cookie not found in auth/refresh/ response',
      )
    }
    const responseJson = await response.json()
    return {
      refreshToken: refreshTokenResponse,
      ...responseJson,
    }
  }

  validateToken(data: ValidateTokenRequest) {
    return this.ky
      .post('auth/token/validate/', {
        json: data,
      })
      .json<ValidateTokenResponse>()
  }

  //Buyers methods

  // Mondu Buy Now, Pay Later methods
  startMonduApplication(data: MonduApplicationRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              const errorBody = await error.response.clone().json()

              const startMonduApplicationUnprocessableContentResult =
                startMonduApplicationUnprocessableContentErrorSchema.safeParse(
                  errorBody,
                )
              if (startMonduApplicationUnprocessableContentResult.success) {
                return new StartMonduApplicationUnprocessableContentError(
                  error,
                  startMonduApplicationUnprocessableContentResult.data,
                )
              }

              const countryNotSupportedResult =
                startMonduApplicationCountryNotSupportedErrorSchema.safeParse(
                  errorBody,
                )
              if (countryNotSupportedResult.success) {
                return new StartMonduApplicationCountryNotSupportedError(
                  error,
                  countryNotSupportedResult.data,
                )
              }

              return error
            },
          ],
        },
      })
      .post('mondu/apply/', { json: data })
      .json<MonduApplication>()
  }

  // Vat methods
  validateVat(data: VatValidationPostRequestBodyRequest) {
    return this.ky
      .extend({
        hooks: {
          afterResponse: [
            // We can end up with 429 rate limiting on this endpoint very easily as we use it during form validation,
            // If we get a 429, we don't want the client to keep retrying, so we'll convert it to a validity response of 'UNABLE_TO_VALIDATE'
            // which is the same we would get if the service was down, and so the client won't retry
            (_request, _options, response) => {
              if (response.status === 429) {
                const newResponseBody: VatValidationPostResponse = {
                  countryCode: data.countryCode,
                  taxNumber: data.taxNumber,
                  companyName: '',
                  validationStatus: 'UNABLE_TO_VALIDATE',
                }
                return Response.json(newResponseBody, {
                  status: 200,
                  headers: response.headers,
                })
              }
            },
          ],
        },
      })
      .post('vat/validation/', { json: data })
      .json<VatValidationPostResponse>()
  }
  getVat() {
    return this.ky.get('vat/').json<VatList>()
  }

  // Brand methods
  getBrands(params: {
    page?: number
    size?: number
    premium?: boolean
    slugs?: string[]
  }) {
    const searchParams = new URLSearchParams()
    if (params.page) {
      searchParams.append('page', String(params.page))
    }
    if (params.size) {
      searchParams.append('size', String(params.size))
    }
    if (params.premium) {
      searchParams.append('premium', String(params.premium))
    }
    if (params.slugs) {
      params.slugs.forEach((slug) => {
        searchParams.append('slug', slug)
      })
    }
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 400) return error
              const invalidSlugsSchema = z.object({
                code: z.literal('invalid_slugs'),
              })
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                invalidSlugsSchema.safeParse(errorBody)
              if (parsedErrorBodyResult.success) {
                return new InvalidSlugsError(error)
              }
              return error
            },
          ],
        },
      })
      .get(`brands/?${searchParams.toString()}`)
      .json<PaginatedBrandList>()
  }
  getBrandContacts({
    page,
    size,
    search,
  }: { page?: number; size?: number; search?: string } = {}) {
    const searchParams = new URLSearchParams()

    if (page) {
      searchParams.append('page', String(page))
    }

    if (size) {
      searchParams.append('size', String(size))
    }

    if (search) {
      searchParams.append('search', search)
    }

    return this.ky
      .get(`brands/contact/?${searchParams.toString()}`)
      .json<PaginatedBrandContactList>()
  }
  getBrandRecommendations(slug: string) {
    return this.ky
      .get(`brands/${slug}/recommendations/`)
      .json<RecommendedBrandsGetResponse>()
  }
  createBrandsRequest(data: BrandRequestRequest[]) {
    return this.ky.post('brands/request/', { json: data }).json<void>()
  }

  // Cart methods
  getActiveCart() {
    return this.ky.get(`carts/active/`).json<Cart>()
  }
  buyersActiveCart() {
    return this.ky.get(`buyers/carts/active/`).json<CartSummary>()
  }
  watchListMissingProducts(qid: string) {
    return this.ky.post(`carts/${qid}/watchlist-missing-products/`).json<void>()
  }
  getActiveCartAllocations() {
    return this.ky.get(`carts/active/allocations/`).json<CartAllocationList>()
  }
  getBuyersActiveCartAllocations() {
    return this.ky
      .get(`buyers/carts/active/allocations/`)
      .json<AllocationsList>()
  }
  getAllocationLines(allocationFid: string) {
    return this.ky
      .get(`buyers/carts/active/allocations/${allocationFid}/lines/`)
      .json<AllocationLineListResponse>()
  }
  emptyActiveCart() {
    return this.ky.post(`carts/active/empty/`).json<Cart>()
  }
  createCartLine({
    data: { gtin, offerQid, ...data },
  }: {
    data: Omit<CartLineRequestWritable, 'gtin' | 'offerQid'> &
      // these conditions make sure that we are not passing invalid data combinations to the BE: we can pass either a gtin or an offerQid, not both.
      (
        | {
            offerQid: CartLineRequest['offerQid']
            gtin?: never
          }
        | {
            offerQid?: never
            gtin: CartLineRequestWritable['gtin']
          }
      )
  }) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              const errorBody = await error.response.clone().json()

              const offersBasedPricingModelSchema = z.object({
                allocationLineQuantity: z.number(),
                availableQuantity: z.number(),
              })
              const parsedOffersBasedPricingModelResult =
                offersBasedPricingModelSchema.safeParse(errorBody)

              if (parsedOffersBasedPricingModelResult.success) {
                return new OffersBasedPricingModelCartLineQuantityExceededError(
                  error,
                  {
                    allocationLineQuantity:
                      parsedOffersBasedPricingModelResult.data
                        .allocationLineQuantity,
                    availableQuantity:
                      parsedOffersBasedPricingModelResult.data
                        .availableQuantity,
                  },
                )
              }

              const cartLineQuantityExceededSchema = z.object({
                availableQuantity: z.number(),
                cartLineQuantity: z.number().optional(),
                allocationLineQuantity: z.number().optional(),
              })
              const parsedErrorBodyResult =
                cartLineQuantityExceededSchema.safeParse(errorBody)
              if (parsedErrorBodyResult.success) {
                return new CartLineQuantityExceededError(error, {
                  availableQuantity:
                    parsedErrorBodyResult.data.availableQuantity,
                  cartLineQuantity: parsedErrorBodyResult.data.cartLineQuantity,
                })
              }

              return error
            },
          ],
        },
      })
      .post(`carts/active/lines/`, {
        json: {
          ...data,
          ...(offerQid ? { offerQid } : { gtin }),
        },
      })
      .json<CartLine>()
  }
  optimizeCart(data: OptimizeCartRequest) {
    return this.ky
      .post(`carts/active/optimize/`, { json: data })
      .json<Checkout>()
  }
  updateCartAllocationLine({
    allocationQid,
    lineQid,
    data,
  }: {
    allocationQid: string
    lineQid: string
    data: PatchedCartAllocationLineRequest
  }) {
    return this.ky
      .patch(`carts/active/allocations/${allocationQid}/lines/${lineQid}/`, {
        json: data,
      })
      .json<void>()
  }
  deleteCartAllocationLine({
    allocationQid,
    lineQid,
  }: {
    allocationQid: string
    lineQid: string
  }) {
    return this.ky
      .delete(`carts/active/allocations/${allocationQid}/lines/${lineQid}/`)
      .json<void>()
  }
  deleteCartAllocation({ allocationQid }: { allocationQid: string }) {
    return this.ky
      .delete(`carts/active/allocations/${allocationQid}/`)
      .json<void>()
  }
  startBuyersCartUpload(data: CartUploadRequest) {
    return this.ky
      .post(`buyers/carts/active/upload/`, { json: data })
      .json<{ taskId: string }>()
  }
  getBuyersCartUpload(taskId: string) {
    return this.ky
      .get(`buyers/carts/active/upload/${taskId}/`)
      .json<CartUploadResponse>()
  }

  cancelBuyersCartUpload(taskId: string) {
    return this.ky
      .post(`buyers/carts/active/upload/${taskId}/cancel/`)
      .json<CartUploadCancelResponse>()
  }

  uploadCartPreviewGtins(data: CartPreviewGtinsData) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status === 400) {
                const errorBody = await error.response.clone().json()

                // Handle error code: missing_required_fields
                const missingRequiredFieldsError = z.object({
                  code: z.literal('missing_required_fields'),
                })
                const missingFieldsResult =
                  missingRequiredFieldsError.safeParse(errorBody)
                if (missingFieldsResult.success) {
                  return new UploadCartPreviewMissingRequiredFieldsError(error)
                }

                // Handle error code: no_processable_gtins (can download error file)
                const noProcessableGtinsError = z.object({
                  code: z.literal('no_processable_gtins'),
                })
                const noProcessableResult =
                  noProcessableGtinsError.safeParse(errorBody)
                if (noProcessableResult.success) {
                  return new UploadCartPreviewNoProcessableGtinsError(error)
                }

                // Handle error code: invalid_file_type
                const invalidFileTypeError = z.object({
                  code: z.literal('invalid_file_type'),
                })
                const invalidFileTypeResult =
                  invalidFileTypeError.safeParse(errorBody)
                if (invalidFileTypeResult.success) {
                  return new UploadCartPreviewInvalidFileTypeError(error)
                }
              }

              return error
            },
          ],
        },
      })
      .post('buyers/carts/active/preview/gtins/', { json: data })
      .json<UploadCartPreview>()
  }
  uploadCartPreview(data: UploadCartPreviewRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status === 400) {
                const errorBody = await error.response.clone().json()

                // Handle error code: missing_required_fields
                const missingRequiredFieldsError = z.object({
                  code: z.literal('missing_required_fields'),
                })
                const missingFieldsResult =
                  missingRequiredFieldsError.safeParse(errorBody)
                if (missingFieldsResult.success) {
                  return new UploadCartPreviewMissingRequiredFieldsError(error)
                }

                // Handle error code: no_processable_gtins (can download error file)
                const noProcessableGtinsError = z.object({
                  code: z.literal('no_processable_gtins'),
                })
                const noProcessableResult =
                  noProcessableGtinsError.safeParse(errorBody)
                if (noProcessableResult.success) {
                  return new UploadCartPreviewNoProcessableGtinsError(error)
                }

                // Handle error code: invalid_file_type
                const invalidFileTypeError = z.object({
                  code: z.literal('invalid_file_type'),
                })
                const invalidFileTypeResult =
                  invalidFileTypeError.safeParse(errorBody)
                if (invalidFileTypeResult.success) {
                  return new UploadCartPreviewInvalidFileTypeError(error)
                }
              }

              return error
            },
          ],
        },
      })
      .post('carts/active/upload-preview/', { json: data })
      .json<UploadCartPreview>()
  }
  /**
   * Accepts a **Upload Cart file key** and returns a **Blob** of the errors file for the upload cart preview.
   *
   * The file contains the errors per row.
   */
  retrieveUploadCartPreviewErrorsFile(data: UploadCartPreviewRequest) {
    const formData = new FormData()
    formData.append('file_key', data.fileKey)
    return this.ky
      .post('carts/active/upload-errors/', {
        json: {
          fileKey: data.fileKey,
        },
      })
      .blob()
  }
  buyersCleanupCart() {
    return this.ky
      .post(`buyers/carts/active/cleanup/`)
      .json<CartAllocationList>()
  }
  recordOfferAvailability(data: OfferAvailabilityRequest) {
    return this.ky
      .post(`carts/offer-availability/`, { json: data })
      .json<void>()
  }
  // Category methods
  getCategories(
    params: { page?: number; size?: number; slugs?: string[] } = {},
  ) {
    const searchParams = new URLSearchParams()
    if (params.page) {
      searchParams.append('page', String(params.page))
    }
    if (params.size) {
      searchParams.append('size', String(params.size))
    }
    if (params.slugs) {
      params.slugs.forEach((slug) => searchParams.append('slug', slug))
    }
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 400) return error
              const errorBody = await error.response.clone().json()
              const invalidSlugsSchema = z.object({
                code: z.literal('invalid_slugs'),
              })
              const parsedErrorBodyResult =
                invalidSlugsSchema.safeParse(errorBody)
              if (parsedErrorBodyResult.success) {
                return new InvalidSlugsError(error)
              }
              return error
            },
          ],
        },
      })
      .get(`categories/?${searchParams.toString()}`)
      .json<PaginatedCategoryResponseList>()
  }
  getCategory(qidOrSlug: string) {
    return this.ky
      .get(`categories/${qidOrSlug}/`)
      .json<CategoryDetailResponse>()
  }

  // Checkout methods
  getBuyersCheckout() {
    return this.ky
      .get(`buyers/checkouts/active/`)
      .json<CheckoutRetrieveUpdate>()
  }
  getCheckoutLines(params: { page?: number; size?: number } = {}) {
    const searchParams = new URLSearchParams()
    if (params.page) {
      searchParams.append('page', String(params.page))
    }
    if (params.size) {
      searchParams.append('size', String(params.size))
    }
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              return error
            },
          ],
        },
      })
      .get(`checkouts/active/lines/?${searchParams.toString()}`)
      .json<PaginatedCheckoutLineList>()
  }
  updateCheckout(data: PatchedCheckoutRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 400) return error
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                updateCheckoutBadRequestErrorSchema.safeParse(errorBody)
              if (parsedErrorBodyResult.success) {
                return new UpdateCheckoutBadRequestError(
                  error,
                  parsedErrorBodyResult.data,
                )
              }
              return error
            },
          ],
        },
      })
      .patch(`checkouts/active/`, { json: data })
      .json<Checkout>()
  }
  buyersUpdateCheckout(data: PatchedCheckoutRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 400) return error
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                updateCheckoutBadRequestErrorSchema.safeParse(errorBody)
              if (parsedErrorBodyResult.success) {
                return new UpdateCheckoutBadRequestError(
                  error,
                  parsedErrorBodyResult.data,
                )
              }
              return error
            },
          ],
        },
      })
      .patch(`buyers/checkouts/active/`, { json: data })
      .json<CheckoutRetrieveUpdate>()
  }
  getPlaidInstitutions(params: { limit?: number; search?: string }) {
    const searchParams = new URLSearchParams()

    searchParams.append('limit', String(params.limit ?? 20))

    if (params.search) {
      searchParams.append('search', params.search)
    }

    return this.ky
      .get(`buyers/checkouts/plaid-institutions/?${searchParams}`)
      .json<PlaidInstitution[]>()
  }
  /*
   Sending allocationFid will filter the checkout to only include lines that are
   allocated to the specified supplier.
  */
  validateCheckout(data: CheckoutValidateRequest) {
    return this.ky
      .post<CheckoutValidationResponse>(`checkouts/active/validate/`, {
        json: data,
      })
      .json()
  }
  buyersCheckoutsPrepare(data: CheckoutPrepareRequest) {
    return this.ky
      .post<CheckoutValidationResponse>(`buyers/checkouts/active/prepare/`, {
        json: data,
      })
      .json()
  }
  /**
   *
   * @deprecated
   */
  completeCheckout(data: CheckoutCompleteRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              const handledErrorSchema = z.object({
                code: z.enum([
                  'buyer_cannot_checkout',
                  'allocation_mov_not_met',
                  'no_checkout_lines',
                  'orderline_price_mismatch',
                  'orderline_quantity_mismatch',
                  'discount_percentage_changed',
                  'invalid_invoicing_option',
                ]),
              })
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                handledErrorSchema.safeParse(errorBody)

              if (!parsedErrorBodyResult.success) {
                return error
              }

              const { code } = parsedErrorBodyResult.data

              switch (code) {
                case 'buyer_cannot_checkout': {
                  return new BuyerCannotCheckoutError(error)
                }
                case 'allocation_mov_not_met': {
                  return new AllocationMovNotMetError(error)
                }
                case 'no_checkout_lines': {
                  return new NoCheckoutLinesError(error)
                }
                case 'orderline_price_mismatch': {
                  return new OrderlinePriceMismatchError(error)
                }
                case 'orderline_quantity_mismatch': {
                  return new OrderlineQuantityMismatchError(error)
                }
                case 'discount_percentage_changed': {
                  return new DiscountPercentageChangedError(error)
                }
                case 'invalid_invoicing_option': {
                  return new InvalidInvoicingOptionError(error)
                }
              }
            },
          ],
        },
      })
      .post(`checkouts/active/complete/`, { json: data })
      .json<CheckoutCompleteResponse>()
  }

  buyersCompleteCheckout(data: CheckoutCompleteRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              const handledErrorSchema = z.object({
                code: z.enum([
                  'buyer_cannot_checkout',
                  'allocation_mov_not_met',
                  'no_checkout_lines',
                  'orderline_price_mismatch',
                  'orderline_quantity_mismatch',
                  'discount_percentage_changed',
                  'invalid_invoicing_option',
                  'bnpl_provider_unavailable',
                  'invalid_company_name',
                  'invalid_tax_number',
                  'invalid_tax_number_format',
                  'country_mismatch',
                ]),
                vatCompanyName: z.string().optional(),
              })
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                handledErrorSchema.safeParse(errorBody)

              if (!parsedErrorBodyResult.success) {
                return error
              }

              const { code } = parsedErrorBodyResult.data

              switch (code) {
                case 'buyer_cannot_checkout': {
                  return new BuyerCannotCheckoutError(error)
                }
                case 'allocation_mov_not_met': {
                  return new AllocationMovNotMetError(error)
                }
                case 'no_checkout_lines': {
                  return new NoCheckoutLinesError(error)
                }
                case 'orderline_price_mismatch': {
                  return new OrderlinePriceMismatchError(error)
                }
                case 'orderline_quantity_mismatch': {
                  return new OrderlineQuantityMismatchError(error)
                }
                case 'discount_percentage_changed': {
                  return new DiscountPercentageChangedError(error)
                }
                case 'invalid_invoicing_option': {
                  return new InvalidInvoicingOptionError(error)
                }
                case 'bnpl_provider_unavailable': {
                  return new BnplProviderUnavailableError(error)
                }
                case 'invalid_company_name': {
                  return new VatCompanyNameMismatchError(
                    error,
                    parsedErrorBodyResult.data.vatCompanyName ?? null,
                  )
                }
                case 'invalid_tax_number':
                case 'invalid_tax_number_format':
                case 'country_mismatch': {
                  return new VatTaxNumberInvalidError(error)
                }
              }
            },
          ],
        },
      })
      .post(`buyers/checkouts/active/complete/`, { json: data })
      .json<CheckoutCompleteResponse>()
  }

  // Claim methods
  getClaim(qid: string) {
    return this.ky.get(`claims/${qid}/`).json<Claim>()
  }
  createClaim(data: ClaimRequest) {
    return this.ky.post<Claim>('claims/', { json: data }).json()
  }
  createLostShipmentClaim(data: LostShipmentClaimRequest) {
    return this.ky
      .post<ClaimQid>('claims/lost-shipment-claim/', { json: data })
      .json()
  }
  validateClaimEvidence(data: ClaimEvidenceQuestionEvaluationRequestRequest) {
    return this.ky
      .post<ClaimEvidenceQuestionEvaluationResponse>(
        'claims/evidence-evaluation/',
        {
          json: data,
        },
      )
      .json()
  }

  disputeClaim(claimQid: string, data: ClaimDisputeInputRequest) {
    return this.ky
      .post(`claims/${claimQid}/dispute/`, { json: data })
      .json<void>()
  }

  getBuyerClaims(
    params: {
      search?: string
      page?: number
      size?: number
      status?: OrderClaimStatus[]
    } = {},
  ) {
    const searchParams = new URLSearchParams()
    if (params.search) {
      searchParams.append('search', params.search)
    }
    if (params.page) {
      searchParams.append('page', String(params.page))
    }
    if (params.size) {
      searchParams.append('size', String(params.size))
    }
    if (params.status) {
      params.status.forEach((status) => {
        searchParams.append('status', status)
      })
    }
    return this.ky
      .get(`buyers/claims/?${searchParams.toString()}`)
      .json<PaginatedBuyerClaimSummaryList>()
  }

  getClaimDetail(qid: string) {
    return this.ky
      .get(`claims/history/${qid}/`)
      .json<ClaimHistoryDetailOutput>()
  }

  getClaimHistory(params: {
    page?: number
    claimCategory?:
      | 'RESOLVED_CLAIMS'
      | 'DISPUTABLE_CLAIMS'
      | 'RETURNED_TO_SENDER'
      | 'SELLER_AT_FAULT'
    reason?: IssueType[]
    sort?: `${'' | '-'}${'resolution_date' | 'price' | 'refund_cycle'}`
    recoupmentCycle?: (
      | 'JANUARY'
      | 'FEBRUARY'
      | 'MARCH'
      | 'APRIL'
      | 'MAY'
      | 'JUNE'
      | 'JULY'
      | 'AUGUST'
      | 'SEPTEMBER'
      | 'OCTOBER'
      | 'NOVEMBER'
      | 'DECEMBER'
    )[]
  }) {
    const searchParams = new URLSearchParams()

    if (params.page) {
      searchParams.append('page', String(params.page))
    }

    if (params.claimCategory) {
      searchParams.append('claimCategory', params.claimCategory)
    }

    if (params.reason) {
      params.reason.forEach((reason) => {
        if (reason) searchParams.append('reason', reason)
      })
    }

    if (params.sort) {
      searchParams.append('sort', params.sort)
    }

    if (params.recoupmentCycle) {
      params.recoupmentCycle.forEach((cycle) => {
        if (cycle) searchParams.append('recoupmentCycle', cycle)
      })
    }

    return this.ky
      .get(`sellers/claims/history/?${searchParams}`)
      .json<PaginatedClaimHistoryOutputList>()
  }

  getSaleWithHiddenOffers() {
    return this.ky(`sales/hidden/`).json<SaleWithHiddenOffers[]>()
  }

  // Email methods
  validateEmail(data: EmailValidationPostRequest) {
    return this.ky
      .post('email/validation/', { json: data })
      .json<EmailValidationPostResponse>()
  }

  // Order methods
  /** Creates a new cart using this order's items */
  reorder(orderQid: string) {
    return this.ky.post(`orders/${orderQid}/reorder/`).json<Cart>()
  }
  getInternalOrderSales(qid: string) {
    return this.ky
      .get(`internal/orders/${qid}/sales/`)
      .json<InternalOrderSales[]>()
  }
  createOrderIssue(qid: string, data: OrderSaleIssueInputRequest) {
    return this.ky.post(`orders/${qid}/issue/`, { json: data }).json<void>()
  }

  // Variant methods
  getBuyersVariantsOffers(
    variantFid: string,
    params: {
      maxEstimatedDeliveryTimeFilter?: number
      maxMovFilter?: number
    } = {},
  ) {
    const searchParams = new URLSearchParams()
    if (params.maxEstimatedDeliveryTimeFilter !== undefined) {
      searchParams.append(
        'max_estimated_delivery_time_filter',
        String(params.maxEstimatedDeliveryTimeFilter),
      )
    }
    if (params.maxMovFilter !== undefined) {
      searchParams.append('max_mov_filter', String(params.maxMovFilter))
    }
    return this.ky
      .get(`buyers/variants/${variantFid}/offers/?${searchParams.toString()}`)
      .json<VariantOffersResponse>()
  }

  getBuyersVariantsOffersSupplier(variantFid: string, supplierAlias: string) {
    return this.ky
      .get(`buyers/variants/${variantFid}/offers/suppliers/${supplierAlias}/`)
      .json<SupplierOfferResponse>()
  }

  getBuyersVariant(variantFid: string) {
    return this.ky.get(`buyers/variants/${variantFid}/`).json<VariantOutput>()
  }

  getVariantsOffersSearch(
    params: {
      query?: string
      page?: number
      size?: number
      brands?: string[]
      categories?: string[]
      minPrice?: number
      maxPrice?: number
      country?: Country
      cartAllocationQid?: string
      showWatchlistedOnly?: boolean
      savedSearch?: string
      curatedSearch?: string[]
    } = {},
    { cacheTimeSeconds }: { cacheTimeSeconds?: number } = {},
  ) {
    const searchParams = new URLSearchParams()
    if (params.query) {
      searchParams.append('query', params.query)
    }
    if (params.page) {
      searchParams.append('page', String(params.page))
    }
    if (params.size) {
      searchParams.append('size', String(params.size))
    }

    if (params.brands) {
      params.brands.forEach((brand) => {
        searchParams.append('brand_name', brand)
      })
    }
    if (params.categories) {
      params.categories.forEach((category) => {
        searchParams.append('category_slug', category)
      })
    }
    if (params.minPrice) {
      searchParams.append('min_price', String(params.minPrice))
    }
    if (params.maxPrice) {
      searchParams.append('max_price', String(params.maxPrice))
    }
    if (params.country) {
      searchParams.append('country', params.country)
    }

    if (params.cartAllocationQid) {
      searchParams.append('cart_allocation_qid', params.cartAllocationQid)
    }
    if (params.showWatchlistedOnly) {
      searchParams.append(
        'show_watchlisted_only',
        String(params.showWatchlistedOnly),
      )
    }

    if (params.savedSearch) {
      searchParams.append('saved_search', params.savedSearch)
    }

    if (params.curatedSearch) {
      params.curatedSearch.forEach((curatedSearchValue) => {
        searchParams.append('curated_search', curatedSearchValue)
      })
    }

    const fetchOptions = cacheTimeSeconds
      ? ({
          cache: `force-cache`,
          next: { revalidate: cacheTimeSeconds },
        } as const)
      : undefined

    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 404) return error

              /**
               * The backend uses a 404 for a search with an not existing category.
               * We are checking for the code not_found in order not to throw in case of this particular error
               *   {
               *     "message": "Category with name jewellery-cleaning-care321 does not exist.",
               *     "code": "not_found"
               *   }
               */
              const variantSearchWithNonExistingCategorySchema = z.object({
                code: z.literal('not_found'),
              })
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                variantSearchWithNonExistingCategorySchema.safeParse(errorBody)
              if (parsedErrorBodyResult.success) {
                return new VariantSearchWithNonExistingCategoryError(error)
              }

              return error
            },
          ],
        },
      })
      .get(`search/offers/?${searchParams.toString()}`, fetchOptions)
      .json<PaginatedOffersSearch>()
  }

  getVariantsSearchForSupplier(
    params: {
      query?: string
      page?: number
      size?: number
      brands?: string[]
      categories?: string[]
      minPrice?: number
      maxPrice?: number
      country?: Country
      recommendationsForGtin?: string
      stockAvailability?: 'in_stock' | 'out_of_stock' | 'all'
      cartAllocationQid?: string
      showWatchlistedOnly?: boolean
      savedSearch?: string
      curatedSearch?: string[] | string
    } = {},
  ) {
    const searchParams = new URLSearchParams()
    if (params.query) {
      searchParams.append('query', params.query)
    }
    if (params.page) {
      searchParams.append('page', String(params.page))
    }
    if (params.size) {
      searchParams.append('size', String(params.size))
    }
    if (params.brands) {
      params.brands.forEach((brand) => {
        searchParams.append('brand_name', brand)
      })
    }
    if (params.categories) {
      params.categories.forEach((category) => {
        searchParams.append('category_slug', category)
      })
    }
    if (params.minPrice) {
      searchParams.append('min_price', String(params.minPrice))
    }
    if (params.maxPrice) {
      searchParams.append('max_price', String(params.maxPrice))
    }
    if (params.country) {
      searchParams.append('country', params.country)
    }
    if (params.recommendationsForGtin) {
      searchParams.append(
        'recommendations_for_gtin',
        params.recommendationsForGtin,
      )
    }
    if (params.stockAvailability) {
      searchParams.append('stock_availability', params.stockAvailability)
    }
    if (params.cartAllocationQid) {
      searchParams.append('cart_allocation_qid', params.cartAllocationQid)
    }
    if (params.showWatchlistedOnly) {
      searchParams.append(
        'show_watchlisted_only',
        String(params.showWatchlistedOnly),
      )
    }

    if (params.savedSearch) {
      searchParams.append('saved_search', params.savedSearch)
    }

    if (params.curatedSearch) {
      if (Array.isArray(params.curatedSearch)) {
        params.curatedSearch.forEach((curatedSearchValue) => {
          searchParams.append('curated_search', curatedSearchValue)
        })
      } else {
        searchParams.append('curated_search', params.curatedSearch)
      }
    }

    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status !== 404) return error

              /**
               * The backend uses a 404 for a search with an not existing category.
               * We are checking for the code not_found in order not to throw in case of this particular error
               *   {
               *     "message": "Category with name jewellery-cleaning-care321 does not exist.",
               *     "code": "not_found"
               *   }
               */
              const variantSearchWithNonExistingCategorySchema = z.object({
                code: z.literal('not_found'),
              })
              const errorBody = await error.response.clone().json()
              const parsedErrorBodyResult =
                variantSearchWithNonExistingCategorySchema.safeParse(errorBody)
              if (parsedErrorBodyResult.success) {
                return new VariantSearchWithNonExistingCategoryError(error)
              }

              return error
            },
          ],
        },
      })
      .get(
        `variants/offers/search/${params.cartAllocationQid}/?${searchParams.toString()}`,
      )
      .json<PaginatedOffersRecommendationsSearch>()
  }

  getVariantsOffersSearchSuggestions(
    params: {
      country?: Country
      query?: string
      recommendationsForGtin?: string
    } = {},
  ) {
    const searchParams = new URLSearchParams()
    if (params.country) {
      searchParams.append('country', params.country)
    }
    if (params.query) {
      searchParams.append('query', params.query)
    }
    if (params.recommendationsForGtin) {
      searchParams.append(
        'recommendations_for_gtin',
        params.recommendationsForGtin,
      )
    }
    return this.ky
      .get(`variants/offers/search/suggestions/?${searchParams.toString()}`)
      .json<SearchSuggestions>()
  }

  getVariantsOffersSearchSupplierSuggestions(
    cartAllocationQid: string,
    params: {
      country?: Country
      query?: string
      recommendationsForGtin?: string
    } = {},
  ) {
    const searchParams = new URLSearchParams()

    if (params.country) {
      searchParams.append('country', params.country)
    }
    if (params.query) {
      searchParams.append('query', params.query)
    }
    if (params.recommendationsForGtin) {
      searchParams.append(
        'recommendations_for_gtin',
        params.recommendationsForGtin,
      )
    }
    return this.ky
      .get(
        `variants/offers/search/${cartAllocationQid}/suggestions/?${searchParams.toString()}`,
      )
      .json<SearchSuggestions>()
  }

  getVariantsOffersSearchFacetsBrand(
    params: {
      brandQuery?: string
      query?: string
      categories?: string[]
      country?: Country
      maxPrice?: number
      minPrice?: number
      showWatchlistedOnly?: boolean
      savedSearch?: string
    } = {},
  ) {
    const searchParams = new URLSearchParams()
    if (params.brandQuery) {
      searchParams.append('brand_query', params.brandQuery)
    }
    if (params.query) {
      searchParams.append('query', params.query)
    }

    if (params.categories) {
      params.categories.forEach((category) => {
        searchParams.append('category_slug', category)
      })
    }

    if (params.country) {
      searchParams.append('country', params.country)
    }
    if (params.maxPrice) {
      searchParams.append('max_price', String(params.maxPrice))
    }
    if (params.minPrice) {
      searchParams.append('min_price', String(params.minPrice))
    }
    if (params.showWatchlistedOnly) {
      searchParams.append('show_watchlisted_only', 'true')
    }

    return this.ky
      .get(`variants/offers/search/facets/brand/?${searchParams.toString()}`)
      .json<BrandNameFacetSearch>()
  }
  getVariantsOffersSearchCartAllocationQidFacetsBrand(
    cartAllocationQid: string,
    params: {
      brandQuery?: string
      query?: string
      categories?: string[]
      country?: Country
      maxPrice?: number
      minPrice?: number
      showWatchlistedOnly?: boolean
      savedSearch?: string
      curatedSearch?: string
    } = {},
  ) {
    const searchParams = new URLSearchParams()
    if (params.brandQuery) {
      searchParams.append('brand_query', params.brandQuery)
    }
    if (params.query) {
      searchParams.append('query', params.query)
    }

    if (params.categories) {
      params.categories.forEach((category) => {
        searchParams.append('category_slug', category)
      })
    }
    if (params.country) {
      searchParams.append('country', params.country)
    }
    if (params.maxPrice) {
      searchParams.append('max_price', String(params.maxPrice))
    }
    if (params.minPrice) {
      searchParams.append('min_price', String(params.minPrice))
    }
    if (params.showWatchlistedOnly) {
      searchParams.append('show_watchlisted_only', 'true')
    }

    if (params.savedSearch) {
      searchParams.append('saved_search', params.savedSearch)
    }

    return this.ky
      .get(
        `variants/offers/search/${cartAllocationQid}/facets/brand/?${searchParams.toString()}`,
      )
      .json<BrandNameFacetSearch>()
  }
  getSavedSearch() {
    return this.ky.get(`search/saved/`).json<SavedSearch>()
  }
  updateSavedSearch(data: SavedSearchUpdateRequest) {
    return this.ky.put(`search/saved/`, { json: data }).json<void>()
  }
  getSearchBrands(params: {
    page?: number | null
    size?: number | null
    query?: string | null
  }) {
    const searchParams = new URLSearchParams()
    if (params.page) {
      searchParams.append('page', String(params.page))
    }
    if (params.size) {
      searchParams.append('size', String(params.size))
    }

    if (params.query) {
      searchParams.append('query', params.query)
    }

    return this.ky
      .get(`search/brands/?${searchParams.toString()}`)
      .json<PaginatedBrandSearch>()
  }
  createVariantsRequest(data: VariantRequestRequest[]) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              const errorBody = await error.response.clone().json()
              // We get given back an array of either objects with gtin errors, or empty objects
              // for items that passed validation, it's not very conventient to work with
              // so transform this into just an array of the invalid gtins
              const errorSchema = z
                .array(
                  z.union([
                    z.object({
                      gtin: z.object({
                        code: z.literal('invalid_gtin_provided'),
                        gtin: z.string(),
                      }),
                    }),
                    z.object({}),
                  ]),
                )
                .transform((items) =>
                  items
                    .map((item) => ('gtin' in item ? item.gtin.gtin : null))
                    .filter((item) => item !== null),
                )

              const parsedErrorBodyResult = errorSchema.safeParse(errorBody)
              if (parsedErrorBodyResult.success) {
                return new InvalidGtinsProvidedError(error, {
                  invalidGtins: parsedErrorBodyResult.data,
                })
              }

              return error
            },
          ],
        },
      })
      .post(`variants/request/`, { json: data })
      .json<void>()
  }
  getOffersSupplier(supplierAlias: string) {
    return this.ky.get(`offers/suppliers/${supplierAlias}/`).json<Supplier>()
  }

  // Wallet methods
  getWallet(qid: string) {
    return this.ky.get(`wallets/${qid}/`).json<Wallet>()
  }
  getWalletLines(
    qid: string,
    params: {
      page?: number
      size?: number
      source: 'EXTRICABLE' | 'INEXTRICABLE' | 'ALL'
    },
  ) {
    const searchParams = new URLSearchParams()
    if (params.page) {
      searchParams.append('page', String(params.page))
    }
    if (params.size) {
      searchParams.append('size', String(params.size))
    }
    if (params.source && params.source !== 'ALL') {
      // We don't actually send 'ALL' to the backend, it's just there as a value to make sure consumers are clear about the type of lines they're getting
      searchParams.append('source', params.source)
    }
    return this.ky
      .get(`wallets/${qid}/lines/?${searchParams.toString()}`)
      .json<PaginatedWalletLineList>()
  }
  applyWallet(qid: string, data: CreateMembershipRequest) {
    return this.ky.post(`wallets/${qid}/apply/`, { json: data }).json<Wallet>()
  }
  withdrawWallet(qid: string, data: WalletWithdrawalRequest) {
    return this.ky
      .post(`wallets/${qid}/withdraw/`, { json: data })
      .json<Wallet>()
  }

  // Seller methods
  getSellerRecommendationsLatest() {
    return this.ky
      .get(`seller-recommendations/latest/`)
      .json<SellerRecommendationResponse>()
  }

  // Offer methods
  getOffer(offerQid: string) {
    return this.ky.get(`offers/${offerQid}/`).json<Offer>()
  }

  getOffers(params: {
    page?: number
    size?: number
    status?: string[]
    brands?: string[]
    sort?: 'price' | 'inventory' | '-price' | '-inventory'
  }) {
    const searchParams = new URLSearchParams()
    if (params.status?.length) {
      params.status.forEach((status) => {
        if (status) searchParams.append('status', status)
      })
    }
    if (params.brands?.length) {
      params.brands.forEach((brand) => {
        if (brand) searchParams.append('brand', brand)
      })
    }
    if (params.sort) {
      switch (params.sort) {
        case '-price': {
          searchParams.set('order', '-original_price')
          break
        }
        case 'price': {
          searchParams.set('order', 'original_price')
          break
        }

        default: {
          searchParams.set('order', params.sort)
        }
      }
    }

    if (params.page) {
      searchParams.set('page', params.page.toString())
    }

    if (params.size) {
      searchParams.set('size', params.size.toString())
    }

    return this.ky.get(`offers/`, { searchParams }).json<PaginatedOfferList>()
  }

  getOffersSearch(query: string) {
    const searchParams = new URLSearchParams()
    searchParams.append('search', query)
    return this.ky
      .get(`offers/search/?${searchParams.toString()}`)
      .json<OfferSearch[]>()
  }

  getOffersInfo() {
    return this.ky.get(`offers/info/`).json<OfferInfo>()
  }

  getOffersSellerBrands() {
    return this.ky.get(`offers/seller/brands/`).json<Brand[]>()
  }

  getOffersSellerBrandRestrictions() {
    return this.ky
      .get(`offers/seller/brand-restrictions/`)
      .json<SellerBrandRestrictionRead[]>()
  }

  getOffersSellerBrandRestriction(qid: string) {
    return this.ky
      .get(`offers/seller/brand-restrictions/${qid}/`)
      .json<SellerBrandRestrictionRead>()
  }

  createOffersSellerBrandRestriction(
    data: CreateSellerBrandRestrictionRequest,
  ) {
    return this.ky
      .post(`offers/seller/brand-restrictions/`, { json: data })
      .json<SellerBrandRestrictionRead>()
  }
  updateOffersSellerBrandRestriction(
    qid: string,
    data: UpdateSellerBrandRestrictionRequest,
  ) {
    return this.ky
      .put(`offers/seller/brand-restrictions/${qid}/`, { json: data })
      .json<SellerBrandRestrictionRead>()
  }

  deleteOffersSellerBrandRestriction(qid: string) {
    return this.ky
      .delete(`offers/seller/brand-restrictions/${qid}/`)
      .json<void>()
  }

  getStocklistSourceStatus() {
    return this.ky
      .get(`sellers/stocklist-source/status/`)
      .json<StocklistSourceStatus>()
  }

  getStocklistSources(params: {
    page: number
    pageSize: number
    status?: StocklistSourceExpiryStatus
  }) {
    const searchParams = new URLSearchParams()

    searchParams.append('page', String(params.page))
    searchParams.append('page_size', String(params.pageSize))

    if (params.status !== undefined) {
      searchParams.append('status', String(params.status))
    }

    return this.ky
      .get(`sellers/stocklist-sources/?${searchParams.toString()}`)
      .json<PaginatedStocklistSourcesResult>()
  }

  getStocklistSource(sourceQid: string) {
    return this.ky
      .get(`sellers/stocklist-sources/${sourceQid}/`)
      .json<StocklistSourceInfoSchema>()
  }

  getStocklistSourceNames(params: { filterExpired?: boolean }) {
    const searchParams = new URLSearchParams()

    if (params.filterExpired !== undefined) {
      searchParams.append('filter_expired', String(params.filterExpired))
    }

    return this.ky
      .get(`sellers/stocklist-sources/names/?${searchParams.toString()}`)
      .json<Array<StocklistSourceNameSchema>>()
  }

  getStocklistSourceOffers(params: {
    sourceQid: string
    page: number
    pageSize: number
    brands?: string[]
    ordering?: OfferOrdering
  }) {
    const searchParams = new URLSearchParams()

    searchParams.append('page', String(params.page))
    searchParams.append('page_size', String(params.pageSize))

    params.brands?.forEach((brand) => {
      searchParams.append('brand', brand)
    })

    if (params.ordering) {
      searchParams.append('ordering', params.ordering)
    }

    return this.ky
      .get(
        `sellers/stocklist-sources/${params.sourceQid}/offers/?${searchParams.toString()}`,
      )
      .json<PaginatedOffersResult>()
  }

  // Seller lead methods
  getSellerLead(slug: string) {
    return this.ky.get(`sellerleads/${slug}/`).json<SellerLead>()
  }

  getSellerLeads() {
    return this.ky.get(`sellerleads/`).json<SellerLeadListItem[]>()
  }

  createSellerLead(variables: CreateSellerLeadRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status === 400) {
                const emailAlreadyUsed = z.object({
                  email: z.string().array().or(z.string()),
                })
                const hasError = emailAlreadyUsed.safeParse(
                  await error.response.clone().json(),
                )
                if (hasError.success) {
                  return new SellerLeadsEmailAlreadyUsedError(error)
                }
              }

              return error
            },
          ],
        },
      })
      .post(`sellerleads/`, { json: variables })
      .json<SellerLead>()
  }

  // sellers methods
  getSellersStats() {
    return this.ky.get(`sellers/performance-stats/`).json<SellerStatsOutput>()
  }

  registerAlternativeOfferingsInterest() {
    return this.ky.post(`sellers/has-seen-alternative-offerings/`).json<void>()
  }

  // Sales methods
  getSale(qid: string) {
    return this.ky.get(`sales/${qid}/`).json<Sale>()
  }

  getSales(params: {
    status?: Sale['status'][]
    order?:
      | 'committed_total'
      | '-committed_total'
      | 'expired_at'
      | '-expired_at'
      | 'paid_at'
      | '-paid_at'
      | 'priority'
    page?: number
    hasSalelineQuantitiesConfirmed?: boolean
    hasShipments?: boolean
    hasBookedWithQogita?: boolean
    hasInvoiceForDownload?: boolean
    hasRead?: boolean
    expiredFrom?: string
    destination?: string
  }) {
    const searchParams = new URLSearchParams()

    if (params.page) {
      searchParams.append('page', String(params.page))
    }
    if (params.order) {
      searchParams.append('order', String(params.order))
    }
    if (params.expiredFrom) {
      searchParams.append('expiredFrom', String(params.expiredFrom))
    }
    if (params.hasRead !== undefined) {
      searchParams.append('hasRead', String(params.hasRead))
    }
    if (params.hasShipments !== undefined) {
      searchParams.append('has_shipments', String(params.hasShipments))
    }
    if (params.hasSalelineQuantitiesConfirmed !== undefined) {
      searchParams.append(
        'has_saleline_quantities_confirmed',
        String(params.hasSalelineQuantitiesConfirmed),
      )
    }
    if (params.hasBookedWithQogita !== undefined) {
      searchParams.append(
        'has_booked_with_qogita',
        String(params.hasBookedWithQogita),
      )
    }
    if (params.hasInvoiceForDownload !== undefined) {
      searchParams.append(
        'has_invoice_for_download',
        String(params.hasInvoiceForDownload),
      )
    }
    if (params.destination) {
      searchParams.append('destination', params.destination)
    }
    if (params.status) {
      for (const status of params.status) {
        searchParams.append('status', status)
      }
    }

    return this.ky
      .get(`sales/?${searchParams.toString()}`)
      .json<PaginatedSaleList>()
  }

  getSalesSearch(query: string) {
    const searchParams = new URLSearchParams()
    searchParams.append('search', query)
    return this.ky
      .get(`sales/search/?${searchParams.toString()}`)
      .json<SaleSearch[]>()
  }

  createSaleIssue(qid: string, data: SaleIssueInputRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status === 400) {
                const data = await error.response.clone().json()

                const isSaleIssueTicketAlreadyExistsError = z
                  .object({
                    code: z.literal(
                      'sale_decline_or_quantity_reduction_ticket_already_exists',
                    ),
                  })
                  .safeParse(data).success

                if (isSaleIssueTicketAlreadyExistsError) {
                  return new SaleIssueTicketAlreadyExistsError(error)
                }
              }
              return error
            },
          ],
        },
      })
      .post(`sales/${qid}/issue/`, { json: data })
      .json<void>()
  }

  confirmSalelineQuantities(qid: string) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status === 400) {
                const data = await error.response.clone().json()
                const isMissingReductionReasonError = z
                  .object({
                    nonFieldErrors: z
                      .object({
                        errorCode: z.literal(
                          'SALE_LINES_REDUCTION_REASON_REQUIRED',
                        ),
                      })
                      .array(),
                  })
                  .safeParse(data).success

                if (isMissingReductionReasonError) {
                  return new ConfirmSalelineQuantitiesMissingReductionReasonError(
                    error,
                  )
                }
              }

              return error
            },
          ],
        },
      })
      .post(`sales/${qid}/confirm_saleline_quantities/`)
      .json<null>()
  }

  updateSaleSalelines(qid: string, data: SaleLinesBulkUpdateInputRequest[]) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status === 400) {
                const data = await error.response.clone().json()
                const isHighValueOrderUnderfulfillmentError = z
                  .object({
                    code: z.literal(
                      'committed_quantities_under_fulfillment_exception',
                    ),
                  })
                  .safeParse(data).success

                if (isHighValueOrderUnderfulfillmentError) {
                  return new HighValueOrderUnderfulfillmentError(error)
                }
              }
              return error
            },
          ],
        },
      })
      .put(`sales/${qid}/lines/`, { json: data })
      .json<SaleLineGenericOutput[]>()
  }

  declineSale(qid: string, data: SaleDeclineRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status === 400) {
                const data = await error.response.clone().json()

                const isManualDeclineBlocked = z
                  .object({
                    code: z.literal('high_value_order_cannot_be_declined'),
                  })
                  .safeParse(data).success

                if (isManualDeclineBlocked) {
                  return new SaleCannotBeDeclinedError(error)
                }
              }

              if (error.response.status === 400) {
                const data = await error.response.clone().json()

                const isManualDeclineBlocked = z
                  .object({
                    code: z.literal('sale_cannot_be_declined'),
                  })
                  .safeParse(data).success

                if (isManualDeclineBlocked) {
                  return new SaleCannotBeDeclinedError(error)
                }
              }

              return error
            },
          ],
        },
      })
      .post(`sales/${qid}/decline/`, { json: data })
      .json<void>()
  }

  getSaleLines(qid: string, params: { page?: number; size?: number } = {}) {
    const searchParams = new URLSearchParams()
    if (params.page) {
      searchParams.append('page', String(params.page))
    }
    if (params.size) {
      searchParams.append('size', String(params.size))
    }
    return this.ky
      .get(`sales/${qid}/lines/?${searchParams.toString()}`)
      .json<PaginatedSaleLineGenericOutputList>()
  }

  getSaleBookableCarrier(
    qid: string,
    params: {
      /**
       * This param must be set for the backend to behave correctly, hence it's not optional.
       * Related backend code: https://github.com/qogita/canary/blob/f543aee2564b9967aa503057cdd87853f26311e0/canary/sale/views/bookable_carriers.py#L35-L41
       * */
      hasDangerousGoods: boolean
      isPallet?: boolean
    },
  ) {
    const searchParams = new URLSearchParams()
    searchParams.append(
      'has_dangerous_goods',
      params.hasDangerousGoods ? 'true' : 'false',
    )
    if (params.isPallet) {
      searchParams.append('is_pallet', 'true')
    }

    return this.ky
      .get(`sales/${qid}/bookable-carriers/?${searchParams.toString()}`)
      .json<BookableCarrier[]>()
  }

  getSaleDocuments(qid: string) {
    return this.ky.get(`sales/${qid}/documents/`).json<File[]>()
  }

  updateSaleDocument(
    qid: string,
    params: {
      documentQid: string
      metadata: { documentType: string }
    },
  ) {
    const formBody = new FormData()
    if (params.metadata)
      formBody.append('metadata', JSON.stringify(params.metadata))
    return this.ky
      .patch(`sales/${qid}/document/${params.documentQid}/`, {
        body: formBody,
      })
      .json<File>()
  }

  deleteSaleDocument(qid: string, documentQid: string) {
    return this.ky.delete(`sales/${qid}/document/${documentQid}/`).json<void>()
  }

  createSaleDocument(qid: string, data: CreateSaleDocumentRequest) {
    const formBody = new FormData()
    formBody.append('file', data.file)
    if (data.metadata) {
      formBody.append('metadata', JSON.stringify(data.metadata))
    }

    return this.ky
      .post(`sales/${qid}/document/`, { body: formBody })
      .json<File>()
  }

  getSaleCarrierBooking(qid: string) {
    return this.ky
      .extend({
        hooks: {
          afterResponse: [
            async (request, options, response) => {
              if (response.status === 404) {
                // We expect sales to not have a carrier booking
                // until they start the ship with Qogita flow
                return new Response(null)
              }
              if (response.ok) {
                const data = await response.clone().json()
                try {
                  z.object({ status: z.literal('SUCCEEDED') }).parse(data)
                  return response
                } catch {
                  // The backend might return a failed carrier booking,
                  // in which case we assume there is no carrier booking
                  // and allow downstream consumers to create a new one
                  return new Response(null)
                }
              }
              return response
            },
          ],
        },
      })
      .get(`sales/${qid}/carrier_booking/`)
      .json<SaleCarrierBookingOutput | null>()
  }

  postSaleRead(qid: string) {
    return this.ky.post(`sales/${qid}/read/`).json<null>()
  }

  updateSale(qid: string, data: PatchedSaleRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status === 400) {
                const data = await error.response.clone().json()
                const isExceededMaxShippingFeeError = z
                  .object({
                    sellerShippingFee: z
                      .literal('EXCEEDED_MAXIMUM_SHIPPING_FEE_AMOUNT')
                      .array(),
                  })
                  .safeParse(data).success
                if (isExceededMaxShippingFeeError) {
                  return new ExceededMaxShippingFeeError(error)
                }

                const isExceededMaxSellerVatError = z
                  .object({
                    sellerVat: z.object({
                      nonFieldErrors: z.array(
                        z.object({
                          errorCode: z.literal('EXCEEDED_MAXIMUM_VAT_AMOUNT'),
                        }),
                      ),
                    }),
                  })
                  .safeParse(data).success
                if (isExceededMaxSellerVatError) {
                  return new ExceededMaxSellerVatError(error)
                }
              }
              return error
            },
          ],
        },
      })
      .patch(`sales/${qid}/`, { json: data })
      .json<Sale>()
  }

  createSaleCarrierBooking(qid: string, data: SaleCarrierBookingInputRequest) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status === 400) {
                const data = await error.response.clone().json()
                const isCarrierBookingPickUpDateNotAvailableError = z
                  .object({
                    code: z.literal('pickup_date_not_available_exception'),
                  })
                  .safeParse(data).success

                if (isCarrierBookingPickUpDateNotAvailableError) {
                  return new SaleCarrierBookingPickUpDateNotAvailableError(
                    error,
                  )
                }

                const isSellerShippingAddressTooLongError = z
                  .object({
                    code: z
                      .literal('seller_shipping_address_line_one_too_long')
                      .or(
                        z.literal('seller_shipping_address_line_two_too_long'),
                      ),
                  })
                  .safeParse(data).success

                if (isSellerShippingAddressTooLongError) {
                  return new SaleCarrierBookingSellerShippingAddressTooLongError(
                    error,
                  )
                }

                const isNoDangerousGoodsButUserSelectedDangerousGoodsError = z
                  .object({
                    code: z.literal(
                      'no_dangerous_goods_detected_but_user_selected_dangerous_goods',
                    ),
                  })
                  .safeParse(data).success

                if (isNoDangerousGoodsButUserSelectedDangerousGoodsError) {
                  return new SaleCarrierBookingNoDangerousGoodsButUserSelectedDangerousGoodsError(
                    error,
                  )
                }

                const isDGUnserviceableDestinationOrOriginError = z
                  .object({
                    code: z.literal('dhl_unserviceable_destination_or_origin'),
                  })
                  .safeParse(data).success

                if (isDGUnserviceableDestinationOrOriginError) {
                  return new SaleCarrierBookingDHLUnserviceableDestinationError(
                    error,
                  )
                }

                const parcelWeightBelowMinimumError = z
                  .object({
                    code: z.literal('parcel_weight_below_minimum'),
                    message: z.string().min(1),
                  })
                  .safeParse(data)

                if (parcelWeightBelowMinimumError.success) {
                  return new SaleCarrierBookingParcelWeightBelowMinimumError(
                    error,
                    parcelWeightBelowMinimumError.data.message,
                  )
                }
              }
              return error
            },
          ],
        },
      })
      .post(`sales/${qid}/carrier_booking/`, { json: data })
      .json<SaleCarrierBookingOutput>()
  }

  salePayComplete(saleQid: string) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status === 400) {
                const data = await error.response.clone().json()

                const isMaxShippingFeeError = z
                  .object({
                    price: z.array(
                      z.literal('EXCEEDED_MAXIMUM_SHIPPING_FEE_AMOUNT'),
                    ),
                  })
                  .safeParse(data).success

                if (isMaxShippingFeeError) {
                  return new SalePayCompleteMaxShippingFeeExceededError(error)
                }

                // Sale lines reduction reason is required.
                const isSalePayCompleteMissingReductionReasonError = z
                  .object({
                    nonFieldErrors: z
                      .object({
                        erroCode: z.literal(
                          'SALE_LINES_REDUCTION_REASON_REQUIRED',
                        ),
                      })
                      .array(),
                  })
                  .safeParse(data).success

                if (isSalePayCompleteMissingReductionReasonError) {
                  return new SalePayCompleteSalelineMissingReductionReasonError(
                    error,
                  )
                }

                const maxVatExceededResult = z
                  .object({
                    nonFieldErrors: z.array(
                      z.object({
                        errorCode: z.literal('EXCEEDED_MAXIMUM_VAT_AMOUNT'),
                        expectedVatAmount: z.string(),
                      }),
                    ),
                  })
                  .transform((value) => value.nonFieldErrors[0])
                  .safeParse(data)
                if (maxVatExceededResult.success) {
                  return new SalePayCompleteMaxVatExceededError(error, {
                    maxValue: maxVatExceededResult.data?.expectedVatAmount,
                  })
                }
              }

              return error
            },
          ],
        },
      })
      .post(`sales/${saleQid}/paycomplete/`)
      .json<Sale>()
  }

  // Sale lines methods
  updateSaleLine({
    saleQid,
    saleLineQid,
    data,
  }: {
    saleQid: string
    saleLineQid: string
    data: PatchedSaleLineGenericRequest
  }) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status === 400) {
                const data = await error.response.clone().json()
                const isQuantityExceedsRequestedAmountError = z
                  .object({
                    quantity: z.object({
                      errorCode: z.literal('QUANTITY_EXCEEDS_REQUESTED_AMOUNT'),
                    }),
                  })
                  .safeParse(data).success

                if (isQuantityExceedsRequestedAmountError) {
                  return new SaleLineQuantityExceedsRequestedAmountError(error)
                }

                const isHighValueOrderUnderfulfillmentError = z
                  .object({
                    code: z.literal(
                      'committed_quantities_under_fulfillment_exception',
                    ),
                  })
                  .safeParse(data).success

                if (isHighValueOrderUnderfulfillmentError) {
                  return new HighValueOrderUnderfulfillmentError(error)
                }
              }
              return error
            },
          ],
        },
      })
      .put(`sales/${saleQid}/lines/${saleLineQid}/`, { json: data })
      .json<SaleLineGenericOutput>()
  }

  // Carriers
  getCarriers({ page, size }: { page?: number; size?: number } = {}) {
    const searchParams = new URLSearchParams()
    if (page) {
      searchParams.append('page', String(page))
    }
    if (size) {
      searchParams.append('size', String(size))
    }
    return this.ky
      .get(`carriers/?${searchParams.toString()}`)
      .json<PaginatedShippingCarrierList>()
  }

  // Sellers methods
  acceptSellersSla() {
    return this.ky.post('sellers/accept-sla/').json<null>()
  }

  getSellerRecommendations() {
    return this.ky.get('seller-recommendations/latest?format=xlsx').blob()
  }

  // Shipment methods
  deleteShipment(qid: string) {
    return this.ky.delete(`shipments/${qid}/`).json<null>()
  }

  createShipments(data: ShipmentInputRequest[]) {
    return this.ky
      .extend({
        hooks: {
          beforeError: [
            async (error) => {
              if (error.response.status === 400) {
                const data = await error.response.clone().json()

                const isInvalidCodeError = z
                  // convert array of objects containing array of invalid codes,
                  // to a single array of unique strings
                  // where the strings are the invalid codes
                  .object({ code: z.string().array().nonempty().nullish() })
                  .array()
                  .nonempty()
                  .transform((data) =>
                    Array.from(
                      new Set(
                        data.flatMap((item) => item.code || '').filter(Boolean),
                      ),
                    ),
                  )
                  .safeParse(data)
                if (isInvalidCodeError.success) {
                  return new InvalidShipmentCodeError(error, {
                    invalidCodes: isInvalidCodeError.data,
                  })
                }
              }
              return error
            },
          ],
        },
      })
      .post('shipments/', { json: data })
      .json<SellerShipmentsResponse>()
  }

  // internal initial check
  createInternalInitialCheck(data: InitialCheckRequestRequestWritable) {
    return this.ky
      .post(`internal/initialcheck/`, { json: data })
      .json<InitialCheckResponse>()
  }

  getInternalInitialCheckTask(id: string) {
    return this.ky.get(`internal/initialcheck/task/${id}/`).json<{
      result: InitialCheckTaskResult
      status: 'SUCCESS' | 'FAILURE'
    }>()
  }
}

// These should all eventually be generated from the OpenAPI spec

export type CreateSaleDocumentRequest = Omit<FileRequest, 'file'> & {
  file: globalThis.Blob
}

export type GetCheckoutLinesSearchParams = NonNullable<
  Parameters<CanaryClient['getCheckoutLines']>[0]
>
export type GetOffersSearchParams = Parameters<CanaryClient['getOffers']>[0]
export type GetSaleLinesSearchParams = NonNullable<
  Parameters<CanaryClient['getSaleLines']>['1']
>
export type GetAddressesSearchParams = NonNullable<
  Parameters<CanaryClient['getAddresses']>[0]
>

export type GetClaimHistorySearchParams = NonNullable<
  Parameters<CanaryClient['getClaimHistory']>[0]
>

export type GetBrandsSearchParams = NonNullable<
  Parameters<CanaryClient['getBrands']>[0]
>

export type GetBrandContactSearchParams = NonNullable<
  Parameters<CanaryClient['getBrandContacts']>[0]
>

export type GetVariantOffersSearchSearchParams = NonNullable<
  Parameters<CanaryClient['getVariantsOffersSearch']>[0]
>
export type GetVariantsSearchForSupplierSearchParams = NonNullable<
  Parameters<CanaryClient['getVariantsSearchForSupplier']>[0]
>

export type GetVariantsOffersSearchSupplierSuggestionsParams = NonNullable<
  Parameters<CanaryClient['getVariantsOffersSearchSupplierSuggestions']>[1]
>
export type GetVariantsOffersSearchSuggestionsParams = NonNullable<
  Parameters<CanaryClient['getVariantsOffersSearchSuggestions']>[0]
>
export type GetVariantsOffersSearchFacetsBrandSearchParams = NonNullable<
  Parameters<CanaryClient['getVariantsOffersSearchFacetsBrand']>[0]
>
export type GetWalletLinesSearchParams = NonNullable<
  Parameters<CanaryClient['getWalletLines']>[1]
>

export type GetVariantsOffersSearchCartAllocationQidFacetsBrand = NonNullable<
  Parameters<
    CanaryClient['getVariantsOffersSearchCartAllocationQidFacetsBrand']
  >[1]
>
export type GetCategoriesSearchParams = NonNullable<
  Parameters<CanaryClient['getCategories']>[0]
>

export class CartLineQuantityExceededError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public details: { availableQuantity: number; cartLineQuantity?: number },
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'CartLineQuantityExceededError'
  }
}

export class OffersBasedPricingModelCartLineQuantityExceededError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public details: {
      availableQuantity?: number
      allocationLineQuantity?: number
    },
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'OffersBasedPricingModelCartLineQuantityExceededError'
  }
}
export class InvalidSlugsError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'BrandsInvalidSlugsError'
  }
}
export class SellerLeadsEmailAlreadyUsedError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'SellerLeadsEmailAlreadyUsedError'
  }
}

export type BuyerClaimSummary = {
  readonly qid: string
  readonly fid: string
  readonly createdAt: string
  readonly orderQid: string
  readonly orderFid: string
  readonly value: string
  readonly valueCurrency: SellerCurrency
  readonly status: OrderClaimStatus
}

export type PaginatedBuyerClaimSummaryList = {
  count: number
  next: string | null
  previous: string | null
  results: BuyerClaimSummary[]
}

export type GetBuyerClaimsSearchParams = NonNullable<
  Parameters<CanaryClient['getBuyerClaims']>[0]
>
export class BuyerCannotCheckoutError extends HTTPError {
  constructor(httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'BuyerCannotCheckoutError'
  }
}

export class AllocationMovNotMetError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'AllocationMovNotMetError'
  }
}
export class NoCheckoutLinesError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'NoCheckoutLinesError'
  }
}

export class OrderlinePriceMismatchError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'OrderlinePriceMismatchError'
  }
}

export class OrderlineQuantityMismatchError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'OrderlineQuantityMismatchError'
  }
}

export class DiscountPercentageChangedError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'DiscountPercentageChangedError'
  }
}

export class InvalidInvoicingOptionError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'InvalidInvoicingOptionError'
  }
}

export class BnplProviderUnavailableError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'BnplProviderUnavailableError'
  }
}

export class VatCompanyNameMismatchError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public vatCompanyName: string | null,
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'VatCompanyNameMismatchError'
  }
}

export class VatTaxNumberInvalidError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'VatTaxNumberInvalidError'
  }
}

export class InvalidGtinsProvidedError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public details: { invalidGtins: string[] },
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'InvalidGtinsProvidedError'
  }
}

export class InvalidShipmentCodeError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public details: { invalidCodes: string[] },
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'InvalidShipmentCodeError'
  }
}

export class ExceededMaxShippingFeeError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'ExceededMaxShippingFeeError'
  }
}

export class SaleCarrierBookingPickUpDateNotAvailableError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'CarrierBookingPickUpDateNotAvailableError'
  }
}

export class SaleCarrierBookingSellerShippingAddressTooLongError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'SellerShippingAddressTooLongError'
  }
}

export class SaleCarrierBookingNoDangerousGoodsButUserSelectedDangerousGoodsError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name =
      'SaleCarrierBookingNoDangerousGoodsButUserSelectedDangerousGoodsError'
  }
}

export class SaleCarrierBookingDHLUnserviceableDestinationError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'SaleCarrierBookingDHLUnserviceableDestinationError'
  }
}

export class SaleCarrierBookingParcelWeightBelowMinimumError extends HTTPError {
  readonly supplierMessage: string

  constructor(
    private httpError: HTTPError,
    supplierMessage: string,
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'SaleCarrierBookingParcelWeightBelowMinimumError'
    this.supplierMessage = supplierMessage
  }
}

export class SaleLineQuantityExceedsRequestedAmountError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'SaleLineQuantityExceedsRequestedAmountError'
  }
}

export class ExceededMaxSellerVatError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'ExceededMaxSellerVatError'
  }
}

export class SalePayCompleteMaxShippingFeeExceededError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'SalePayCompleteMaxShippingFeeExceededError'
  }
}

export class SalePayCompleteSalelineMissingReductionReasonError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'SalePayCompleteSalelineMissingReductionReasonError'
  }
}

export class ConfirmSalelineQuantitiesMissingReductionReasonError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'ConfirmSalelineQuantitiesMissingReductionReasonError'
  }
}

export class CreateUserBadRequestError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public details: { code: string; message: string } & Partial<
      Record<keyof UserRegisterRequest, string[]>
    >,
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'CreateUserBadRequestError'
  }
}

export class SalePayCompleteMaxVatExceededError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public details: { maxValue?: string },
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'SalePayCompleteMaxVatExceededError'
  }
}

const updateUserBadRequestErrorSchema = z.object({
  code: z.literal('invalid'),
  message: z.string(),
  email: z
    .array(
      z.union([
        z
          .literal('User with this Email already exists.')
          .transform(
            (value) => ({ code: 'ALREADY_EXISTS', message: value }) as const,
          ),
        z
          .string()
          .transform((value) => ({ code: 'INVALID', message: value }) as const),
      ]),
    )
    .optional(),
})
export class UpdateUserBadRequestError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public details: z.infer<typeof updateUserBadRequestErrorSchema>,
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'UpdateUserBadRequestError'
  }
}

const updateUserPasswordBadRequestErrorSchema = z.object({
  code: z.literal('invalid'),
  message: z.string(),
  secret: z.array(z.literal('Invalid input.')),
})
export class UpdateUserPasswordBadRequestError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'IncorrectPasswordError'
  }
}

const createUserBankBadRequestErrorSchema = z.object({
  nonFieldErrors: z.array(z.string()).min(1),
})
export class CreateUserBankBadRequestError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public details: z.infer<typeof createUserBankBadRequestErrorSchema>,
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'CreateUserBankBadRequestError'
  }
}

const checkoutAddressFieldErrorSchema = z.union([
  z.object({
    message: z.string(),
    code: z.string().optional(),
    vatCompanyName: z.string().optional(),
  }),
  z.string(),
])
const legacyUpdateCheckoutBadRequestErrorSchema = z.object({
  code: z.literal('invalid'),
  message: z.string(),
  billingAddressQid: z.array(checkoutAddressFieldErrorSchema).optional(),
  shippingAddressQid: z.array(checkoutAddressFieldErrorSchema).optional(),
  daysDeferred: z.array(z.string()).optional(),
})
function getCheckoutAddressFormField(field: string | null) {
  switch (field) {
    case 'shipping_address_qid':
    case 'shippingAddressQid':
      return 'shippingAddressQid'
    case 'billing_address_qid':
    case 'billingAddressQid':
      return 'billingAddressQid'
    default:
      return undefined
  }
}
/**
 * Flat `CheckoutValidationError` shape returned by `buyers/checkouts/{qid}/`,
 * e.g. `{ field: 'shipping_address_qid', code: 'invalid_company_name', detail, vatCompanyName }`.
 * Normalised into the legacy per-field shape so consumers handle a single format.
 */
const checkoutValidationErrorSchema = z
  .object({
    field: z.string().nullable(),
    code: z.string(),
    detail: z.string(),
    vatCompanyName: z.string().optional(),
  })
  .transform(
    ({
      field,
      code,
      detail,
      vatCompanyName,
    }): z.infer<typeof legacyUpdateCheckoutBadRequestErrorSchema> => {
      const formField = getCheckoutAddressFormField(field)
      return {
        code: 'invalid',
        message: detail,
        ...(formField && {
          [formField]: [{ message: detail, code, vatCompanyName }],
        }),
      }
    },
  )
const updateCheckoutBadRequestErrorSchema = z.union([
  legacyUpdateCheckoutBadRequestErrorSchema,
  checkoutValidationErrorSchema,
])
export class UpdateCheckoutBadRequestError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public details: z.infer<typeof updateCheckoutBadRequestErrorSchema>,
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'UpdateCheckoutBadRequestError'
  }
}

const createAddressBadRequestErrorSchema = z.object({
  code: z.literal('invalid'),
  message: z.string(),
  callingCode: z
    .array(z.literal('The phone number entered is not valid.'))
    .transform(() => ({
      code: 'INVALID_CALLING_CODE' as const,
    }))
    .optional(),
  companyName: z
    .array(
      z
        .object({
          message: z.literal(
            'Address company name must include the VAT company name.',
          ),
          vatCompanyName: z.string(),
        })
        .transform((value) => ({
          ...value,
          code: 'VAT_COMPANY_NAME_MISMATCH' as const,
        })),
    )
    .optional(),
  lineNumber: z
    .array(z.literal('The phone number entered is not valid.'))
    .transform(() => ({
      code: 'INVALID_PHONE_NUMBER' as const,
    }))
    .optional(),
  zipCode: z
    .array(z.literal('invalid'))
    .transform(() => ({
      code: 'INVALID_ZIPCODE' as const,
    }))
    .optional(),
})
export class CreateAddressBadRequestError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public details: z.infer<typeof createAddressBadRequestErrorSchema>,
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'CreateAddressBadRequestError'
  }
}

const updateAddressBadRequestErrorSchema = createAddressBadRequestErrorSchema
export class UpdateAddressBadRequestError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public details: z.infer<typeof updateAddressBadRequestErrorSchema>,
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'UpdateAddressBadRequestError'
  }
}

export class PhoneVerifyThrottleError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public details: { waitSeconds: number },
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'PhoneVerifyThrottleError'
  }
}

const phoneVerifyThrottleErrorSchema = z.object({
  wait: z.string(),
})

const confirmVerifyUserPhoneBadRequestErrorSchema = z.object({
  code: z.literal('authentication_failed'),
})
export class ConfirmVerifyUserPhoneBadRequestError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public details: z.infer<typeof confirmVerifyUserPhoneBadRequestErrorSchema>,
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'ConfirmVerifyUserPhoneBadRequestError'
  }
}

const startMonduApplicationUnprocessableContentErrorSchema = z.object({
  code: z.literal('already_applied'),
})
const startMonduApplicationCountryNotSupportedErrorSchema = z.object({
  code: z.literal('country_not_supported'),
})

export class StartMonduApplicationUnprocessableContentError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public details: z.infer<
      typeof startMonduApplicationUnprocessableContentErrorSchema
    >,
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'StartMonduApplicationUnprocessableContentError'
  }
}

export class StartMonduApplicationCountryNotSupportedError extends HTTPError {
  constructor(
    private httpError: HTTPError,
    public details: z.infer<
      typeof startMonduApplicationCountryNotSupportedErrorSchema
    >,
  ) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'StartMonduApplicationCountryNotSupportedError'
  }
}

export { HTTPError } from 'ky'

export class VariantSearchWithNonExistingCategoryError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'VariantSearchWithNonExistingCategoryError'
  }
}

export class UploadCartPreviewMissingRequiredFieldsError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'UploadCartPreviewMissingRequiredFieldsError'
  }
}

export class UploadCartPreviewNoProcessableGtinsError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'UploadCartPreviewNoProcessableGtinsError'
  }
}

export class UploadCartPreviewInvalidFileTypeError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'UploadCartPreviewInvalidFileTypeError'
  }
}

export type DownloadCatalogMovLimit =
  | '500'
  | '1000'
  | '2500'
  | '5000'
  | '7500'
  | '10000'
  | null

export class SaleCannotBeDeclinedError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'SaleCannotBeDeclinedError'
  }
}

export class HighValueOrderUnderfulfillmentError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'HighValueOrderQuantityReductionError'
  }
}

export class SaleIssueTicketAlreadyExistsError extends HTTPError {
  constructor(private httpError: HTTPError) {
    super(httpError.response, httpError.request, httpError.options)
    this.name = 'SaleIssueTicketAlreadyExistsError'
  }
}
